import {
    GET_MEMBER_DAYBOOK,
    CLEAR_MEMBER_DAYBOOK_STATE,
} from '../../index.types';


export function getMemberDaybook(data) {
    return {
        type: GET_MEMBER_DAYBOOK,
        data
    }
}

export function clearMemberDaybookState() {
    return {
        type: CLEAR_MEMBER_DAYBOOK_STATE
    }
}
